import { jsx as _jsx } from "react/jsx-runtime";
const Iframe = ({ url, height }) => {
    return (_jsx("iframe", { src: url, title: "Iframe Content", width: "100%", height: height }));
};
export default Iframe;
